import * as React from "react";
import { UserDataFilter } from ".";

type Props = {
  user: UserDataFilter;
};

const UserFilterRow = ({ user }: Props) => {
  return <span>{user.name}</span>;
};

export default UserFilterRow;
